const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/perfect-match-elements`,
    saveDiscountTable: `${API_URL}/perfect-match-element/save-discount-table`
};

export default apiUrls;
